import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=2eb42aad&scoped=true&"
import script from "./DeliveryDetail.vue?vue&type=script&lang=tsx&"
export * from "./DeliveryDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=2eb42aad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb42aad",
  null
  
)

export default component.exports